function sortNumber(a, b) {
  return a - b;
}

export default function quantile(array, percentile) {
  if (array === null || typeof array === 'undefined') {
    return '';
  }
  array.sort(sortNumber);
  const index = (percentile / 100) * (array.length - 1);
  if (Math.floor(index) === index) {
    return array[index];
  }
  const i = Math.floor(index);
  const fraction = index - i;
  return array[i] + ((array[i + 1] - array[i]) * fraction);
}
